import { render, staticRenderFns } from "./PaginaExcelMinistero.vue?vue&type=template&id=89811f12"
import script from "./PaginaExcelMinistero.vue?vue&type=script&lang=js"
export * from "./PaginaExcelMinistero.vue?vue&type=script&lang=js"
import style0 from "./PaginaExcelMinistero.vue?vue&type=style&index=0&id=89811f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports